<template>
    <div class="equip-card" :class="{ 'has-avatar': hasAvatar }">
        <div v-if="hasAvatar" class="equip-avatar">
            <slot name="avatar"></slot>
        </div>

        <div class="equip-card-header">
            <span>{{ title }}</span>
            <div v-if="title" class="equip-card-divider"></div>
        </div>

        <div v-if="!hasAvatar" class="equip-tab-list">
            <slot name="tab"></slot>
        </div>

        <div class="equip-card-body">
            <div class="equip-card-content">
                <slot name="content"></slot>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    // ----- props -----
    withDefaults(
        defineProps<{
            title: string;
            hasAvatar?: boolean;
        }>(),
        {
            hasAvatar: false,
        }
    );
</script>

<style scoped lang="scss">
    .equip-card {
        display: grid;
        grid-template-areas: 'equip-card-header' 'equip-tab-list' 'equip-card-body';
        grid-template-columns: 1fr;
        gap: 32px;
        border: 1px solid $grayColorB0;
        border-radius: 8px;
        padding: 48px 64px;

        @media (max-width: 767px) {
            gap: 16px;
            border: 0;
            padding: 16px;
        }

        &.has-avatar {
            grid-template-areas: 'equip-avatar equip-card-header' 'equip-avatar equip-card-body';
            grid-template-columns: 270px 1fr;

            @media (max-width: 767px) {
                grid-template-areas: 'equip-card-header' 'equip-avatar' 'equip-card-body';
                grid-template-columns: 1fr;
            }
        }

        .equip-avatar {
            grid-area: equip-avatar;
        }

        .equip-tab-list {
            grid-area: equip-tab-list;
            overflow-x: auto;
            scrollbar-width: none;
        }

        .equip-card-header {
            grid-area: equip-card-header;
            color: $blueColor_124CBB;
            font-size: 24px;
            font-weight: 700;
            text-align: center;

            .equip-card-divider {
                border-bottom: 1px solid $blueColor_124CBB;
                margin-top: 8px;
                margin-inline: calc((100% - 54px) / 2);
            }
        }

        .equip-card-body {
            grid-area: equip-card-body;
            display: flex;
            flex-direction: column;
            gap: 16px;

            .equip-card-content {
                flex: 1;
                color: $textColor888;
                font-size: 16px;
                text-align: justify;
                word-break: break-word;
            }
        }
    }
</style>
